export default () => {
    if(window.scrollY > 0) {
        window.scrollTo(0, 0)
    }
}